export const DELAY_FOR_ICON_TOOLTIP = 500;
